import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'cleanEmailImgHtml'
})
export class CleanEmailImgHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string): SafeHtml {
    if (!html) return '';
    
    // Remove width and height from img tags
    let cleaned = html.replace(
      /<img([^>]*?)(?:width\s*=\s*["']?\d+["']?|height\s*=\s*["']?\d+["']?)([^>]*?)>/gi,
      '<img$1$2>'
    );
    
    // Remove width/height from style attributes in img tags
    cleaned = cleaned.replace(
      /(<img[^>]*style\s*=\s*["'])([^"']*?)(["'][^>]*>)/gi,
      (match, p1, styles, p3) => {
        const cleanedStyles = styles
          .replace(/width\s*:\s*[^;]+;?/gi, '')
          .replace(/height\s*:\s*[^;]+;?/gi, '');
        return p1 + cleanedStyles + p3;
      }
    );
    
    return this.sanitizer.bypassSecurityTrustHtml(cleaned);
  }
}